import React from 'react';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { IS_PROD } from 'config/constants';
import config from '../config/app';

export const apiMessageFormatHandler = (id, fallback) => (
  <FormattedMessage id={id} defaultMessage={fallback} />
);

export const generateKeyByDynamicFunctionParams = valueArr => {
  const filteredArgs = valueArr?.filter(
    arg => arg !== undefined && arg !== null,
  );
  if (isEmpty(filteredArgs) || filteredArgs?.length === 0) {
    return undefined;
  }
  return filteredArgs
    .map(arg =>
      arg
        .toString()
        .trim()
        .replace(/\s+/g, '')
        .replace(/[^\w\s]/g, ''),
    )
    .join('_');
};

export const getConfigValue = key =>
  IS_PROD ? config.production[key] : config.development[key];

// Absolute URL for a cross-module link — pages that live on the Intouch host
// outside this SPA's publicPath (org settings, member care, audience manager,
// customer status…). Deployed builds resolve on the current origin — the same
// `window.location.origin` convention the dashboard nav (NewDashboard.
// navigateToPath) and org-change redirects use — so the host follows the
// cluster automatically. Local dev runs on localhost, which doesn't serve
// those modules, so reuse the host the dev `api_endpoint` already targets:
// api_endpoint is host-relative in production (→ current origin) and absolute
// to the proxy cluster in development.
export const buildIntouchUrl = urlPath =>
  `${
    new URL(getConfigValue('api_endpoint'), window.location.origin).origin
  }${urlPath}`;

